import { Box, Typography } from "@mui/material";
import React from "react";
import {
    detailDrawerLabelSx,
    detailDrawerValueSx,
} from "./availsPlusDetailStyles";

interface ReadOnlyDetailFieldProps {
    label: string;
    value: string | number | null | undefined;
    /** Shown when value is empty. Defaults to em dash. */
    emptyDisplay?: string;
}

function formatReadOnlyValue(
    value: string | number | null | undefined,
    emptyDisplay = "—"
): string {
    if (value === null || value === undefined || value === "") return emptyDisplay;
    return String(value);
}

export function ReadOnlyTableText({
    children,
    muted = false,
}: {
    children: React.ReactNode;
    muted?: boolean;
}) {
    return (
        <Typography
            variant="body2"
            component="span"
            sx={{
                ...(muted ? detailDrawerLabelSx : detailDrawerValueSx),
                display: "inline",
            }}
        >
            {children}
        </Typography>
    );
}

export default function ReadOnlyDetailField({
    label,
    value,
    emptyDisplay,
}: ReadOnlyDetailFieldProps) {
    const display = formatReadOnlyValue(value, emptyDisplay);

    return (
        <Box aria-readonly="true" sx={{ outline: "none" }}>
            <Typography variant="caption" display="block" sx={{ mb: 0.5, ...detailDrawerLabelSx }}>
                {label}
            </Typography>
            <Typography
                variant="body1"
                component="p"
                sx={{ m: 0, wordBreak: "break-word", ...detailDrawerValueSx }}
            >
                {display}
            </Typography>
        </Box>
    );
}
